module.exports = __webpack_public_path__ + "img/calendar-time.501858a1.webp";